export enum Currency {
  CAD = "CAD",
  USD = "USD",
}
